/**
 * Redux reducer ducks for edit form on profile page
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
import request from 'axios';

/* ACTIONS
================================================================================================ */
const FETCH = 'crowdspring/portfolio/FETCH_ENTRIES';
const FETCH_REQUEST = 'crowdspring/portfolio/FETCH_ENTRIES_REQUEST';
const FETCH_SUCCESS = 'crowdspring/portfolio/FETCH_ENTRIES_SUCCESS';
const FETCH_FAILURE = 'crowdspring/portfolio/FETCH_ENTRIES_FAILURE';
const SAVE = 'crwodspring/portfolio/SAVE_FORM_REVISION';
const CLEAR = 'crowdspring/portfolio/CELAR_FORM_REVISION';
const EDIT_FORM_CHANGE_STEP = 'crowdspring/portfolio/EDIT_FORM_CHANGE_STEP';
const EDIT_FORM_TOGGLE = 'crowdspring/portfolio/EDIT_FORM_TOGGLE';


/* INITIAL STATE
================================================================================================ */
const INITIAL_STATE = {
  formOpen: false,
  currentStep: 'select',
  entries: [],
  isFetching: false,
  isError: false,
  revision: null,
};


/* HELPERS
================================================================================================ */
export const getPortfolioEditForm = (state) => state.profile.portfolio.portfolioForm;


/* REDUCERS
================================================================================================ */
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_SUCCESS:
      return {
        ...state,
        entries: action.payload.results,
        isFetching: false,
      };
    case FETCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    case SAVE:
      return {
        ...state,
        revision: { ...action.payload },
      };
    case CLEAR:
      return {
        ...state,
        revision: null,
      };
    case EDIT_FORM_TOGGLE:
      return {
        ...INITIAL_STATE,
        formOpen: !state.formOpen,
      };
    case EDIT_FORM_CHANGE_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    default:
      return state;
  }
}

/* ACTION CREATORS
================================================================================================ */
export const fetchUserEntries = () => (dispatch, getState) => {
  const username = getState().user.profile_data.username;
  return dispatch({
    type: FETCH,
    promise: request.get(`/api/v1/users/${username}/portfolio_images/available/`)
  });
};

export const saveFormRevisionObject = (modelData) => (
  {
    type: SAVE,
    payload: { ...modelData },
  }
);

export const clearFormRevisionObject = () => (
  {
    type: CLEAR,
  }
);

export function changeEditFormStep(action) {
  return {
    type: EDIT_FORM_CHANGE_STEP,
    payload: action,
  };
}

export function toggleEditForm() {
  return {
    type: EDIT_FORM_TOGGLE,
  };
}
